// ga.ts
import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';

import { TrackingId } from "../data/constant";

interface JourneyEventParams {
    [key: string]: string | number | boolean | undefined;
}

export const initGA = (userId?: string) => {
    const trackingId = process.env.REACT_APP_GA_TRACKING_ID || TrackingId;

    ReactGA.initialize([
        {
            trackingId: trackingId,
            gaOptions: {
                user_id: userId,
            },
        },
    ]);

    if (trackingId.startsWith("GTM-")) {
        TagManager.initialize({
            gtmId: trackingId,
            dataLayer: {
                user_id: userId,
            },
        });
    }

    if (userId) {
        ReactGA.set({ user_id: userId, custom_user_id: userId });
    } else {
        ReactGA.set({ user_id: "", custom_user_id: "" });
        console.log("initGA", "no userId");
    }
};

export const trackEvent = (action: string, userId: string, params?: any) => {
    ReactGA.event(action, {
        ...params,
        user_id: userId,
    });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        user_id: userId,
        ...params,
    });
};

export const trackCustomerJourneyEvent = (
    eventName: string,
    userId: string,
    trackingId: string,
    params: any
) => {
    ReactGA.set({ user_id: userId });

    // GA4: params first, then user_id + tracking_id so they are never overwritten
    ReactGA.event(eventName, {
        ...params,
        user_id: userId,
        trackingId: trackingId,
    });

    // GTM dataLayer: params first, then user_id + tracking_id so tid always goes
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: eventName,
        ...params,
        user_id: userId,
        trackingId: trackingId,
    });
};